<template>
  <div style="display: inline-block;">
    <el-date-picker
      v-model="value"
      type="year"
      placeholder="选择年"
      :size="size?size:'small'"
      @change="handlePickerChange"
    >
    </el-date-picker>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  model: {
    prop: 'year',
    event: 'input'
  },
  props: ['year', 'size'],
  data() {
    return {
      value: new Date()
    }
  },
  watch: {
    year: {
      handler (val) {
        this.value = `${val}-01-01`;  // 日期格式化，避免datePicker组件格式化错误
      }
    },
    value: {
      handler (val) {
        this.$emit('input', moment(val).format('YYYY'));
      },
      immediate: true
    }
  },
  methods: {
    handlePickerChange(date) {
      this.$emit('change', moment(date).format('YYYY'));
    }
  }
}
</script>

<style lang="stylus" scoped>
  >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner
    width 120px
</style>